import React from "react";
import { FilterDataType } from "@home-health-notify/domain";
import {
  FilterBy,
  SelectedFilterListItem,
  SelectedFilterListWrapper,
} from "./SelectedFilters.style";
import { USER_TYPE_TEXT } from "hhn-commons";

const SelectedUserFilters = ({
  filters,
  filterCount,
  defaultFilterCount = 0,
}: {
  filters: FilterDataType | undefined;
  filterCount: number;
  defaultFilterCount?: number;
}) => {
  return (
    filterCount > defaultFilterCount && (
      <SelectedFilterListWrapper>
        {filters?.userRole.map(role => (
          <SelectedFilterListItem key={role}>
            <FilterBy>{role}</FilterBy>
          </SelectedFilterListItem>
        ))}
        {filters?.userType.map(userType => (
          <SelectedFilterListItem key={userType}>
            <FilterBy>
              {USER_TYPE_TEXT[userType as keyof typeof USER_TYPE_TEXT]}
            </FilterBy>
          </SelectedFilterListItem>
        ))}
      </SelectedFilterListWrapper>
    )
  );
};

export default SelectedUserFilters;
